import React, { useRef } from "react";
import Swal from "sweetalert2";
import "../../Cotizardor/Cards/cardcompra.css";
import image1  from "../../../assets/3198777.jpg";
export const EmailComp = ({ onSubmit }) => {
    const emailRef = useRef(null);


    
/**
 * The handleSubmit function retrieves the value of an email input field and passes it as a parameter
 * to the onSubmit function.
 * @param e - The parameter "e" is an event object that represents the event that triggered the
 * function. In this case, it is likely an event object related to a form submission.
 */
  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const username = (emailRef.current?.value || "").trim();

    // Validar vacío
    if (!username) {
      Swal.fire({
        title: "Campo vacío",
        text: "Debe escribir un correo electrónico",
        icon: "warning",
        confirmButtonText: "Ok",
      });
      return;
    }

    // Validación básica de formato de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(username)) {
      Swal.fire({
        title: "Email inválido",
        text: "Ingrese un correo electrónico válido",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }

    onSubmit({ username });
  };

  return (
    <div className="flex justify-center items-center bg-white rounded-xl p-28 max-md:p-10  shadow-lg gap-10">
    <img src={image1} className='w-80 max-md:hidden' alt="" />
    <div className="flex justify-center items-center  flex-col w-80">
      <h2>
        <b>Consultar correo electrónico</b>
      </h2>
      <input 
      placeholder="Email"
      ref={emailRef}
      type="email"
      id="email"
      name="Email"
      className='shadow appearance-none border rounded w-full py-2 my-6 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline'
      required
      />

      <button className="bg-colorprimarygreen text-white border-none p-2 rounded-md hover:bg-colorsecondarygreen w-full" onClick={handleSubmit} >Buscar</button>
    </div>
    </div>
  );
};


// ## Summary
// This code defines a functional component called `EmailComp` that renders a form for inputting an email address. When the form is submitted, the email address is extracted from the input field and passed to a callback function provided as a prop.

// ## Example Usage
// ```javascript
// <EmailComp onSubmit={handleEmailSubmit} />
// ```

// ## Code Analysis
// ### Inputs
// - `onSubmit`: a callback function that will be called when the form is submitted. It takes an object with a `username` property as its argument.
// ___
// ### Flow
// 1. The component renders a styled container with a title and an input field for the email address.
// 2. When the form is submitted, the `handleSubmit` function is called.
// 3. The email address is extracted from the input field using the `emailRef` reference.
// 4. The `onSubmit` callback function is called with an object containing the extracted email address as the `username` property.
// ___
// ### Outputs
// - None. The extracted email address is passed to the `onSubmit` callback function for further processing.
// ___
